import { useMonitoringService, WidgetTypeInterface } from "..";

export function useWidgetTypes(): WidgetTypeInterface[] {
  const MonitoringService = useMonitoringService();

  return MonitoringService.types;
}
